import React, { useState } from 'react';

//Material
import { Box, ClickAwayListener, Rating, TextField, Typography, styled } from '@mui/material';

import ApiService from '../helpers/apiHelper';
import CloseIcon from '@mui/icons-material/Close';
import EmojiPicker from 'emoji-picker-react';
import EmojiEmotionsOutlinedIcon from '@mui/icons-material/EmojiEmotionsOutlined';
import { LetsGoBtn2 } from './Buttons';

const CssTextField = styled(TextField)({
  '& label.Mui-focused': {
    color: '#000000'
  },
  '& label': {
    color: '#7C7C7C',
    opacity: 1,
    fontFamily: 'FixelText-Regular'
  },
  '& .MuiInputBase-root': {
    alignItems: 'end',
    backgroundColor: '#FFFFFF',
    boxShadow: '0px 0px 15px -5px rgba(0, 0, 0, 0.15)',
    borderRadius: '8px'
  },

  fontFamily: 'FixelText-Regular !important',
  margin: '5px 0px',

  '& ::placeholder': {
    color: '#7C7C7C',
    opacity: 1
  },

  '& .MuiInputBase-root.Mui-error': {
    backgroundColor: '#FFE5E5 !important'
  }
});

function RespondForm({ id, setIsOpenFeedbackForm, feedbackSetter, setIsCanWriteFeedback }) {
  const [rating, setRating] = useState(0);
  const [error, setError] = useState('');
  const [ratingError, setRatingError] = useState('');
  const [text, setText] = useState('');
  const [isShowEmoji, setIsShowEmoji] = useState(false);

  const apiFeedback = new ApiService('posts/feedback');
  // const apiFeedback = new ApiService('feedback');
  const handleSend = () => {
    const data = {
      text,
      serviceId: id,
      rating
    };
    if (text.length === 0) {
      setError('Мінімальна довжина відгука: 1 символ');
    } else if (text.length > 500) {
      setError('Максимальна довжина відгука: 500 символів');
    } else if (rating === 0 && text.length === 0) {
      setError('Мінімальна довжина відгука: 1 символ');
      setRatingError('Потрібно обрати оцінку');
    } else if (rating === 0) {
      setRatingError('Потрібно обрати оцінку');
    } else {
      apiFeedback.sendRequest(data).then((res) => {
        setIsCanWriteFeedback(false);
        feedbackSetter(true);
        setIsOpenFeedbackForm(false);
        setError('');
        setRatingError('');
      });
    }
  };

  return (
    <Box
      sx={{
        boxShadow: '0px 0px 15px -5px rgba(0, 0, 0, 0.15)',
        backgroundColor: 'white',
        borderRadius: '20px',
        width: '100%',
        padding: '24px',
        marginTop: '20px',
        position: 'relative'
      }}
    >
      <Typography
        variant="subtitle2"
        sx={{
          fontFamily: 'FixelText-Medium',
          fontSize: { xs: '20px', sm: '24px' },
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: '8px !important',
          textAlign: 'left',
          fontWeight: '500'
        }}
      >
        Додайте ваш відгук!
        <CloseIcon
          // className="bonfair_service_modal-close"
          style={{ cursor: 'pointer', zIndex: 99 }}
          onClick={() => {
            setIsOpenFeedbackForm(false);
          }}
        />
      </Typography>
      <CssTextField
        placeholder="Опиши більш детально свої враження. Нам дійсно важлива твоя думка!"
        variant="outlined"
        multiline
        rows={8}
        fullWidth
        size="normal"
        inputProps={{ style: { textAlign: 'left' } }}
        InputProps={{
          endAdornment: (
            <>
              <EmojiEmotionsOutlinedIcon
                onClick={() => {
                  setIsShowEmoji(!isShowEmoji);
                }}
                sx={{
                    display: {xs:'none', md:'inline-block'},
                  color: '#7C7C7C',
                  cursor: 'pointer',
                  fontSize: '20px',
                  mr: 1
                }}
              />
            </>
          )
        }}
        onChange={(event) => {
          if (isShowEmoji) {
            setIsShowEmoji(false);
          }
          if (event.target.value.length <= 500) setText(event.target.value);
          setError('');
        }}
        value={text}
      />
      {isShowEmoji && (
        <ClickAwayListener
          onClickAway={() => {
            setIsShowEmoji(false);
          }}
        >
          <Box>
            <EmojiPicker
              onEmojiClick={(emojiData, event) => {
                let newStr = `${text}${emojiData.emoji}`;
                setText(newStr);
              }}
              skinTonesDisabled
              searchDisabled
              previewConfig={{ showPreview: false }}
              style={{
                position: 'absolute',
                bottom: error.length !== 0 ? '-80px' : '-100px',
                right: '46px',
                zIndex: '99'
              }}
              width={'60%'}
              height={'300px'}
            />
          </Box>
        </ClickAwayListener>
      )}
      <p
        style={{ margin: '0 5px', color: 'gray', textAlign: 'right', fontSize: '14px' }}
      >{`${text.length} / 500`}</p>
      {error.length !== 0 && (
        <p
          style={{ margin: '0 5px', color: 'red', textAlign: 'left', fontSize: '14px' }}
        >{`${error}`}</p>
      )}
      <Box
        sx={{
          display: 'flex',
          justifyContent: { xs: 'center', sm: 'space-between' },
          flexDirection: 'column',
          height: '100px',
          marginTop: '10px'
        }}
      >
        <Typography
          variant="subtitle"
          sx={{
            fontFamily: 'FixelText-Regular !important',
            fontSize: '16px',
            textAlign: { xs: 'center', sm: 'left' }
          }}
        >
          Оцініть товар*
        </Typography>
        <Rating
          sx={{ width: 'fit-content !important', margin: { xs: '10px auto', sm: '10px 0px' } }}
          precision={1}
          value={rating}
          onChange={(event, value) => setRating(value)}
        />
        {ratingError.length !== 0 && (
          <Typography
            sx={{
              margin: { xs: '0 auto', sm: '0 5px' },
              color: 'red',
              textAlign: 'left',
              fontSize: '14px'
            }}
          >{`${ratingError}`}</Typography>
        )}
      </Box>
      <LetsGoBtn2
        margin={{ xs: '00px auto', sm: '0px' }}
        text="Відправити"
        width={{ xs: '100%', sm: '90px' }}
        onClick={handleSend}
      />
    </Box>
  );
}

export default RespondForm;
